module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.saved) ? _c('article', [(_vm.stage === 'addForeign') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.lang2),
      expression: "lang2",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "Foreign Language",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.lang2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lang2 = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "addNative",
    on: {
      "click": function($event) {
        _vm.stage = 'addNative'
      }
    }
  }, [_vm._v("Next")])] : (_vm.stage === 'addNative') ? [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.lang1),
      expression: "lang1",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "Native Language",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.lang1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lang1 = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "save",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Add")])] : _vm._e()], 2) : _c('article', [_vm._v("\n\tsaving...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c673c68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddVocab.vue
// module id = 96
// module chunks = 2